import type { ReactNode } from 'react';
import { cn } from '@lib/utils';

/**
 * 모바일(xl 미만)에서 섹션을 바로 지나치지 않도록, 제목이 헤더 아래 24px 에 오면 뒤의 여백(holdPx, 기본 320px)을
 * 스크롤하는 동안 멈춰 둔다. 측정 없이 CSS 로만 처리한다.
 *
 * 멈춤 위치 = 배너(--banner-height) + 헤더 바(h-20, 80) + 간격 24 − 섹션 위 여백(py-20, 80).
 * 감싸는 섹션의 모바일 위 여백이 헤더 바 높이와 같은 80 이어야 제목이 24px 떨어진다.
 * 멈춘 동안 섹션 아래로 드러나는 빈 영역은 className 배경으로 채운다(섹션 배경과 맞출 것).
 *
 * fullScreen: 화면 전체를 채우는 섹션(모바일 min-h-svh)을 화면 맨 위(헤더 뒤)에 멈춘다 — 전환 섹션처럼
 * 한 화면에 가운데 정렬로 보여줄 때 쓴다. 섹션 쪽에서 화면 높이와 가운데 정렬을 맡는다.
 */
export default function ScrollHold({
  fullScreen = false,
  holdPx = 320,
  className,
  children,
}: {
  fullScreen?: boolean;
  holdPx?: number;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn(className)}>
      <div
        className={cn(
          'max-xl:sticky',
          fullScreen
            ? 'max-xl:top-0'
            : 'max-xl:top-[calc(var(--banner-height)+24px)]',
        )}
      >
        {children}
      </div>
      <div
        aria-hidden="true"
        className="hidden max-xl:block"
        style={{ height: holdPx }}
      />
    </div>
  );
}
